import { UserMgr } from './mgrs/UserMgr';
import { LoginMgr } from './mgrs/LoginMgr';
import { UserMgrV2 } from './mgrs/UserMgrV2'

export class Controller {
  static _me = null;
  static get() {
    if (this._me == null) {
      this._me = new Controller();
    }
    return this._me;
  }

  constructor() {
  }

  _loginMgrObj = null;
  loginMgr() {
    if (null == this._loginMgrObj) {
      this._loginMgrObj = new LoginMgr();
    }
    return this._loginMgrObj;
  }

  _userMgrObj = null;
  userMgr() {
    if (null == this._userMgrObj) {
      this._userMgrObj = new UserMgr();
    }
    return this._userMgrObj;
  }

  _userMgrV2Obj = null;
  userMgrV2() {
    if (null == this._userMgrV2Obj) {
      this._userMgrV2Obj = new UserMgrV2();
    }
    return this._userMgrV2Obj;
  }

  getUserId() {
    //return this.userMgr().getUserId()
    const cognitoUser = Controller.get().loginMgr().getCurrentUser()
    if (cognitoUser) {
      return cognitoUser.username
    }
    return null;
  }

  setNavigator(history) {
    this.history = history
  }

  pushRoute(route) {
    this.history.push(route)
  }

  pushToHome() {
    if (this.userMgr().isProductSU()) {
      this.pushRoute('/admin')
    } else {
      this.pushRoute('/dashboard')
    }
  }

  logout() {
    //console.log('logout');
    this.loginMgr().signOut();
    this.pushRoute('/login')
  }
}



// WEBPACK FOOTER //
// ./src/common/Controller.js